import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import ButtonUI from '../../../../components/UI/ButtonUI';
import { Row, Modal, Button } from 'react-materialize';
import { showMessageToastCustom, translate } from '../../../../utils/util';
import PhysicalConfirmationService from '../../../../services/PhysicalConfirmationService';
import { Input } from '../../../../components/UI/ComponentsUI';
import { onValueChange } from '../../../../utils/handleChangeHooks';

const ModalUploadBai = (props) => {
    const [selectedFile, setSelectedFile] = useState();
    const [filter, setFilter] = useState({ container: '' });
    const [messages, setMessages] = useState([]);

    useEffect(() => {
        return () => {
            setSelectedFile()
            setMessages([]);
        }
        // eslint-disable-next-line
    }, []);

    const onCancel = (event) => {
        if (props.onCancel) {
            props.onCancel(event);
        }
        close();
    };

    const close = () => {
        if (props.onClose) {
            props.onClose();
        }
    };

    const send = () => {
        const dataSend = {
            mvmNumber: props.physicalConfirmation.mvmNumber,
            journey: props.physicalConfirmation.journey,
            shed: props.sheds ? (props.sheds.find((i) => i.id === props.user.shed)?.code || "") : "",
            container: filter.container
        }

        props.uploadBai(dataSend, selectedFile, (response) => {
            if (response && response.length > 0) {
                setMessages(response || []);
            } else {
                clearFileInput();
                showMessageToastCustom(translate('info', 'general'), translate('file-successfully', 'general'), 1000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                props.onConfirm();
                close();
            }
        })
    };

    const clearFileInput = () => {
        document.getElementById("fileBai").value = "";
        setSelectedFile();
    }


    return (
        <Modal
            open={props.open}
            options={{ dismissible: false }}
            id={props.id || 'ModalReceiptQuantity'}
            actions={
                <Row className="center" style={{ height: "60%" }}>
                    <Button onClick={onCancel} className="col s6 btn waves-effect waves-light btn-flat" modal="close" disabled={props.disabledCancel}>
                        {props.btnCancel ? props.btnCancel : translate('cancel', 'general')}
                    </Button>
                    <ButtonUI onClick={send} text={props.btnConfirm ? props.btnConfirm : translate('add', 'general')} />
                </Row>
            }
        >
            <div>
                {
                    props.open &&
                    <>
                        <Row className="center">
                            <div className="sixth-text-color center">
                                <span className="title col s12">{props.title}</span>
                                <span className="col s12" >{props.content}</span>
                            </div>
                        </Row>
                        <div id="formInput" className='row'>
                            <div className="input-field no-padding col s12">
                                <span className="fourth-text-color">
                                    ATENÇÃO: Será feito apenas para desenhos que não possui identificação iniciada.
                                </span>
                            </div>
                            <div className="input-field no-padding col s12">
                                <input
                                    id="fileBai"
                                    required
                                    type="file"
                                    onClick={clearFileInput}
                                    onChange={(event) => setSelectedFile(event.target.files[0])}
                                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                />
                            </div>
                            <div className="input-field no-padding col s6">
                                <Input
                                    id="container"
                                    name="container"
                                    placeholder="Container"
                                    type="text"
                                    onChange={(event) => onValueChange(event, filter, setFilter)}

                                />
                            </div>
                            {messages.length > 0 &&
                                <div className="input-field no-padding col s12">
                                    <div style={{ display: 'flex', flexDirection: 'column', padding: '15px 0px' }}>
                                        <span className="fourth-text-color">
                                            {translate('erro-upload-bai', 'physical-confirmation')}
                                        </span>
                                        {messages.map((item, index) => (
                                            <span key={index} className="fourth-text-color">
                                                {item}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            }
                        </div>
                    </>
                }
            </div>
        </Modal >
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        sheds: state.configReducer.sheds,
        physicalConfirmation: state.physicalConfirmationReducer.physicalConfirmation,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        uploadBai: (data, file, callback) => {
            dispatch(PhysicalConfirmationService.uploadBai(data, file, callback));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ModalUploadBai));